<template>
  <v-menu
    :value="value"
    left
    transition="scroll-y-transition"
    :nudge-bottom="44"
    :min-width="290"
    :close-on-content-click="false"
    content-class="c360-menu"
    @input="$emit('input', $event)"
  >
    <template #activator="{ attrs, on }">
      <v-btn
        rounded
        elevation="0"
        :height="24"
        class="c360-notifications px-2 py-0"
        :class="[!hasNoUnread && 'c360-button', hasNoUnread && 'c360-notifications-button']"
        v-on="on"
        v-bind="attrs"
      >
        <c360-icon icon="Bell_Notification" :size="16" class="mr-1" />
        <span v-if="!hasNoUnread">{{ quantity }}</span>
      </v-btn>
    </template>
    <v-sheet v-if="isEmpty">
      <!-- Slot to display something when there is no notifications in the list. -->
      <slot name="empty">
        <v-sheet class="d-flex justify-center pa-12">
          <p class="mb-0">You don’t have any notifications.</p>
        </v-sheet>
      </slot>
    </v-sheet>
    <v-sheet v-else class="pa-2">
      <v-virtual-scroll height="250" item-height="42" :items="notifications">
        <template #default="{ item }">
          <!-- Slot to display each individual item as custom component. -->
          <slot name="item" :item="item">
            <v-list-item :key="item.id" dense @click="$emit('item:click', item)" class="mb-1">
              <v-list-item-icon class="mr-2">
                <v-btn
                  icon
                  small
                  class="c360-button--icon"
                  @click.stop="$emit('item:close-click', item)"
                >
                  <c360-icon icon="Close_SM" />
                </v-btn>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title :class="[item.unread && 'font-weight-bold']">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </slot>
        </template>
      </v-virtual-scroll>
      <!-- Slot to display extra info or actions below the notifications list. -->
      <slot name="bottom" />
    </v-sheet>
  </v-menu>
</template>

<script>
  import Vue from 'vue';
  import { C360Icon } from '../../../components/Icon';

  export default Vue.extend({
    name: 'C360NotificationsDropdown',

    components: { C360Icon },

    props: {
      /**
       * Prop for using with v-model.
       */
      value: {
        type: Boolean,
        default: false,
      },

      /**
       * A list of notifications.
       */
      notifications: {
        type: Array,
        default: () => [],
      },
    },

    computed: {
      quantity() {
        return this.notifications.filter((n) => n.unread).length;
      },
      isEmpty() {
        return this.notifications.length === 0;
      },
      hasNoUnread() {
        return this.quantity === 0;
      },
    },
  });
</script>

<style scoped>
  .c360-notifications {
    font-size: 10px;
    font-family: var(--c360-font);
  }

  .c360-notifications-button {
    background: var(--c360-color-light-gray) !important;
  }
</style>
